// Session ID management for analytics tracking

export const getSessionId = (): string => {
  let sessionId = sessionStorage.getItem('nwg_session');

  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem('nwg_session', sessionId);
  }

  return sessionId;
};
